import axios from 'axios';
import config from '../config_client';

const tracking = {
  find: (codeBox) => new Promise((resolve) => {
    const payload = {
      mix: config.connect.apiKey,
      guide: codeBox,
    }
    axios.post(config.connect.path, payload).then((response) => {
      resolve(response.data);
    })
  })
}

export default tracking;